import { useAuth } from 'react-oidc-context';
import { LogIn } from 'lucide-react';
import logoUrl from '../assets/logo.png';

export default function Login() {
  const auth = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-brand-paper via-brand-mint-100 to-brand-sky-100 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl ring-1 ring-brand-sage/20">
        <div className="mb-6 flex flex-col items-center text-center">
          <img
            src={logoUrl}
            alt="360 Balanced Living"
            className="mb-3 h-20 w-20 object-contain"
          />
          <h1 className="font-display text-3xl font-black text-brand-forest">
            Legacy Tracker
          </h1>
        </div>
        <button
          type="button"
          onClick={() => auth.signinRedirect()}
          className="flex w-full items-center justify-center gap-2 rounded-xl bg-brand-lime px-4 py-3 font-display font-black text-brand-forest shadow-sm transition hover:bg-brand-lime-600 active:scale-[0.99]"
        >
          <LogIn className="h-4 w-4" />
          Sign in to continue
        </button>
      </div>
    </div>
  );
}